export const formatTime = (time: string) => {
  const [minutes = '00', seconds = '00'] = time.split(':');

  return `${minutes.padStart(2, '0')}:${seconds.padStart(2, '0')}`;
};
